module.exports = "pegasus/assets/themelp1/product/105.png";